export default __webpack_public_path__ + "static/media/attendance-half.14427cb9.svg";